import React, { useEffect } from "react";
import Banner from "../Common_Component/Banner/Banner";
import Below_Banner_section from "../Common_Component/Below_Banner_section/Below_Banner_section";
import Why_Work_With_Us from "./Why_Work_With_Us/Why_Work_With_Us";
import Growth_Opportunities from "./Growth_Opportunities/Growth_Opportunities";
import Collaborative_Culture from "./Collaborative_Culture/Collaborative_Culture";
import About_Us_Below_Banner_section from "../Common_Component/Below_Banner_section/About_Us_Below_Banner_section";

function Career() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <Banner videoSrc={"/Assets/Vedio/Career/Career.mp4"} />
      <About_Us_Below_Banner_section
        headingText={
          "Be Part of Our Team & Redefine the Future of Advertising At ReachOut Media Tech Pvt. Ltd."
        }
        ContentText={
          "we are always on the lookout for creative, motivated, and innovative individuals who are passionate about transforming the advertising landscape. Whether you're a seasoned professional or just starting your career, we offer a dynamic environment where you can grow, learn, and make an impact."
        }
      />
      {/* <Below_Banner_section
        headingText={
          "Be Part of Our Team & Redefine the Future of Advertising At ReachOut Media Tech Pvt. Ltd."
        }
        ContentText={
          "we are always on the lookout for creative, motivated, and innovative individuals who are passionate about transforming the advertising landscape. Whether you're a seasoned professional or just starting your career, we offer a dynamic environment where you can grow, learn, and make an impact."
        }
      /> */}
      <Why_Work_With_Us />
      <Growth_Opportunities />
      <Collaborative_Culture />

      <div className="container">
        <div className="note_holder">
          <h3>Note:- </h3>
          <h3>
            If you don’t find a suitable job opening, send your resume to 
            <span> maheshwari_hrm@reachoutmediatech.com </span>.
          </h3>
        </div>
      </div>
    </>
  );
}

export default Career;
